import { PageHero, SectionHeading } from "@/components/site/Reveal";
import { PricingSection } from "@/components/site/Pricing";
import { PeakChart } from "@/components/site/PeakChart";
import { FaqList } from "@/components/site/Social";
import { usePageMeta } from "@/lib/seo";

export default function Memberships() {
  usePageMeta(
    "Gym Memberships Queens | Cheap Plans from $60/mo | Iron Pump Gym",
    "Cheap gym membership in Queens. Peak and Off-Peak plans, 6-month, 1-year and 2-year options, couples promo and guest passes. Works at Bayside and Flushing."
  );
  return (
    <>
      <PageHero eyebrow="Memberships" title={<>One price.<br /><span className="text-gold-grad">Two gyms.</span></>}
        sub="Every membership gets you into Bayside and Flushing. Choose Peak for any hour, or save with Off-Peak." image="/images/dumbbells.webp" />
      <PricingSection />
      <section className="mx-auto max-w-7xl px-4 py-20 sm:px-8"><PeakChart /></section>
      <section className="mx-auto grid max-w-7xl gap-10 px-4 pb-24 sm:px-8 lg:grid-cols-[1fr_1.6fr]" data-testid="faq-section">
        <SectionHeading eyebrow="FAQ" title="Questions? Answered.">Still curious? Call either gym or stop by the front desk.</SectionHeading>
        <FaqList />
      </section>
    </>
  );
}
